export default "__VITE_ASSET__DpirWuj$__"